
import { useState, useEffect, useRef, useMemo } from "react";

import "./styles.scss";

import { ReactComponent as FullLogo } from "@assets/logo/M_WHITE_LOGO_FULL.svg";

import { ReactComponent as Hamburger } from "@assets/custom-icons/hamburger.svg";


import * as Material from "@mui/material";


import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import config from '@config'

import {
    AddRounded,
    CloseRounded,
    DarkModeRounded,
    ExitToAppRounded,
    LightModeRounded,
    PeopleRounded,
    SearchRounded,
    WorkspacesRounded,
    HelpRounded,
} from "@mui/icons-material";

import { sendMessageTo } from "@contexts/ChatContext";

import { useAuth } from "@contexts/AuthContext";

import AICircle from "@components/AICircle";
import Popper from "@components/Popper";
import CreateCommunityModal from "@components/_modals/Community/CreateCommunityModal";

import { AutoAwesomeRounded, BuildRounded } from "@mui/icons-material";

import { Button, Text } from "@fragments";
import Notifications from "./Notifications";



export default function Header() {
    const { community } = useCommunity();
    const { user } = useAuth();

    const [open, setOpen] = useState(false);

    const [data, setData] = useState();

    const [loading, setLoading] = useState(true);




    function ActionButtons() {
        const [appearence, setAppearence] = useState(window.appearenceMode)
        const [createModalOpen, setCreateModalOpen] = useState(false);
        const popperRef = useRef();
        const createBtnRef = useRef();

        useEffect(() => {
            function handleAppearenceChange(event) {
                const appearenceMode = event.detail;
                setAppearence(appearenceMode);
            }

            window.addEventListener("appearence-change", handleAppearenceChange);

            return () => {
                window.removeEventListener("appearence-change", handleAppearenceChange);
            };
        }, [])

        function handleCreateClick(e) {
            popperRef.current?.open(
                [
                    {
                        id: 'ai',
                        label: 'Criar comunidade com I.A.',
                        icon: <AutoAwesomeRounded fontSize="small" />,
                        onClick: async () => {
                            window.open(config.communityBuilder);
                            popperRef.current?.close();
                        },
                    },
                    {
                        id: 'manual',
                        label: 'Criar comunidade manualmente',
                        icon: <BuildRounded fontSize="small" />,
                        onClick: async () => {
                            setCreateModalOpen(true);
                            popperRef.current?.close();
                        },
                    },
                ],
                'bottom-end',
                createBtnRef.current
            );
        }

        return (
            <div className="header-right">
                <Popper controlRef={popperRef}>
                    <span ref={createBtnRef}>
                        <Button
                            variant="rounded"
                            color="inverse"
                            endIcon={<AddRounded />}
                            onClick={handleCreateClick}
                            tooltip="Criar nova comunidade"
                            startIcon={<AICircle size={26} />}
                        >
                            Criar
                        </Button>
                    </span>
                </Popper>
                <CreateCommunityModal
                    open={createModalOpen}
                    onClose={() => setCreateModalOpen(false)}
                />
                <Notifications />
                <Button
                    color="overlay"
                    variant="rounded"
                    icon={appearence === 'dark' ? <DarkModeRounded /> : <LightModeRounded />}
                    onClick={() => {
                        setAppearence(window.triggerAppearence())
                    }}
                    tooltip="Mudar tema"
                />
                <Button
                    color="overlay"
                    variant="rounded"
                    icon={<HelpRounded />}
                    onClick={() => {
                        window.open(config.help)
                    }}
                    tooltip="Ajuda"
                />
                <Button
                    onClick={window.logout}
                    variant="rounded"
                    color="overlay"
                    endIcon={<ExitToAppRounded />}
                    tooltip="Sair da plataforma"
                >
                    Sair
                </Button>
            </div>
        );
    }

    const REF_input = useRef();

    function SearchField() {
        const REF_input = useRef(null);

        return (
            <Material.Tooltip
                arrow
                title="Em breve você poderá buscar por conteúdos e pessoas"
                placement="bottom"
            >
                <div className="search-box search-box-disabled">
                    <input
                        placeholder="Pesquisar"
                        ref={REF_input}
                        disabled
                        readOnly
                    />

                    <span className="coming-soon-badge">Em breve</span>

                    <div className="search-icon">
                        <SearchRounded />
                    </div>
                </div>
            </Material.Tooltip>
        );
    }

    const MEMO_TextField = useMemo(() => <SearchField key={open} />, [open]);



    function PersonCard({ info }) {
        return (
            <div
                className="person-card px-1 py-1 fade"
                onClick={() => {
                    sendMessageTo(info);
                    setOpen(false);
                }}
            >
                <img src={info.avatar} className="avatar mt-1" />
                <h5 className="username mt-1">{info.username}</h5>
                <small className="nickname">{info.nickname}</small>
            </div>
        );
    }
    function CommunityCard({ info }) {
        return (
            <div
                className="person-card px-1 py-1 fade"
                onClick={() => {
                    window.navigate('/' + info.slug)
                    setOpen(false)
                }}
            >
                <img src={info.banner} className="discover-community-banner mt-1" />
                <h5 className="username mt-1">{info.name}</h5>
                <small className="nickname">{info.membersTotal || 0} membros</small>
            </div>
        );
    }

    function ItemsCarousel({ items, Component }) {
        return (
            <Carousel
                infinite={false}
                draggable={true}
                responsive={{
                    superLargeDesktop: {
                        breakpoint: { max: 4000, min: 1600 },
                        items: 6,
                    },
                    desktop: {
                        breakpoint: { max: 1600, min: 1024 },
                        items: 5,
                    },
                    tablet: {
                        breakpoint: { max: 1024, min: 768 },
                        items: 3,
                    },
                    mobile: {
                        breakpoint: { max: 768, min: 0 },
                        items: 2,
                    },
                }}
                swipeable={true}
                keyBoardControl={false}
                containerClass="people-result pb-1 px-4"
            >
                {items.map((p, i) => (
                    <Component info={p} key={i} />
                ))}
            </Carousel>
        );
    }

    function Loader() {
        return (
            <div className="result-loading-box">
                {["", "", "", "", ""].map((_, i) => (
                    <Material.Skeleton className="result-box-loader" />
                ))}
            </div>
        );
    }

    return (<>
        <header>

            {<>
                <div className="header-open-sidebar">
                    <Material.IconButton onClick={window.toggleSidebar} className="hamburger-btn">
                        <Hamburger />
                    </Material.IconButton>

                    <FullLogo className="header-logo" />
                </div>
            </>}

            <h3 style={{ transform: "translateY(2px)" }} className="header-username">Olá, {user?.username?.split(" ")[0]}</h3>

            {MEMO_TextField}

            <ActionButtons />
        </header>
        {open && (
            <div className="search-results">
                <div className="results-box">
                    <Text.h3 icon={<PeopleRounded />} value="Pessoas" />

                    {loading ? (
                        <Loader />
                    ) : (
                        <ItemsCarousel
                            items={data?.users || []}
                            Component={PersonCard}
                        />
                    )}

                    <Text.h3 icon={<WorkspacesRounded />} value="Comunidades" />

                    {loading ? (
                        <Loader />
                    ) : (
                        <ItemsCarousel
                            items={data?.communities || []}
                            Component={CommunityCard}
                        />
                    )}
                </div>

                <Material.IconButton
                    onClick={() => setOpen(false)}
                    className="close-search-overlay"
                    children={<CloseRounded color="white" />}
                />
            </div>
        )}
    </>
    );
}